export default {
  state: {
    batchId: '',
    // 选择调解机构页面数据
    activeOrgan: '',
    activeSubOrgan: '',
    activeDispute: '',
    // 案件管辖法院（导入案件使用）
    activeCaseCourt: '',
    caseCourtUndetermined: false,
    // 监管平台id（导入案件使用）
    monitorActId: '',
    // 选择申请人模板页面数据
    selectTemplateForm: {
      pltId: '',
      pltUnit: '',
      pltLicenceNumber: '',
    },
    listPageUpload: false, // 是否需要列表页上传
    materialUploadQuery: {},
  },

  getters: {
    listPageUpload: state => {
      return state.listPageUpload;
    },
    materialUploadQuery: state => {
      return state.materialUploadQuery;
    }
  },
  mutations: {
    SAVE_ACTIVE_ORGAN: (state, _data) => {
      state.activeOrgan = _data;
    },
    SAVE_ACTIVE_SUB_ORGAN: (state, _data) => {
      state.activeSubOrgan = _data;
    },
    SAVE_ACTIVE_DISPUTE: (state, _data) => {
      state.activeDispute = _data;
    },
    SAVE_ACTIVE_CASE_COURT: (state, _data) => {
      state.activeCaseCourt = _data;
    },
    SAVE_CASE_COURT_UNDETERMINED: (state, _data) => {
      state.caseCourtUndetermined = _data;
    },
    SAVE_MONITOR_ACT_ID: (state, _data) => {
      state.monitorActId = _data;
    },
    SAVE_SELECT_TEMPLATE_FORM: (state, _data) => {
      state.selectTemplateForm = JSON.parse(JSON.stringify(_data));
    },
    Save_Batch_Id: (state, _data) => {
      state.batchId = _data;
    },
    SetListPageUpload: (state, result) => {
      state.listPageUpload = result;
    },
    SetMaterialUploadQuery: (state, _data) => {
      state.materialUploadQuery = _data;
    }
  },
  actions: {
    // 保存调解机构
    SaveActiveOrgan({commit}, _data) {
      commit('SAVE_ACTIVE_ORGAN', _data);
    },
    // 保存二级机构
    SaveActiveSubOrgan({commit}, _data) {
      commit('SAVE_ACTIVE_SUB_ORGAN', _data);
    },
    // 保存纠纷类型
    SaveActiveDispute({commit}, _data) {
      commit('SAVE_ACTIVE_DISPUTE', _data);
    },
    // 保存案件管辖法院
    SaveActiveCaseCourt({commit}, _data) {
      commit('SAVE_ACTIVE_CASE_COURT', _data);
    },
    // 保存“暂未确定管辖法院”标识
    SaveCaseCourtUndetermined({commit}, _data) {
      commit('SAVE_CASE_COURT_UNDETERMINED', _data);
    },
    // 保存监管平台id
    SaveMonitorActId({commit}, _data) {
      commit('SAVE_MONITOR_ACT_ID', _data);
    },
    // 保存申请人模板
    SaveSelectTemplateForm({commit}, _data) {
      commit('SAVE_SELECT_TEMPLATE_FORM', _data);
    },
    SaveBatchId({commit}, _data) {
      commit('Save_Batch_Id', _data);
    },
    SetListPageUpload({commit}, _data) {
      commit('SetListPageUpload', _data);
    },
    SetMaterialUploadQuery({commit}, _data) {
      commit('SetMaterialUploadQuery', _data);
    }
  }
};
